import axios from 'axios';
import { API_BASE_URL } from '../config';

// Create axios instance with default configuration
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('user');
    if (token) {
      try {
        const user = JSON.parse(token);
        if (user.token) {
          config.headers.Authorization = `Bearer ${user.token}`;
          console.log('API Request - URL:', config.url);
          console.log('API Request - Token:', user.token.substring(0, 20) + '...');
        }
      } catch (error) {
        console.error('Error parsing user token:', error);
      }
    } else {
      console.log('No user token found in sessionStorage');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('timestamp');
      sessionStorage.removeItem('settingsSynced');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export { apiClient };
export default apiClient;

